import { render, staticRenderFns } from "./Recomendaciones.vue?vue&type=template&id=1a5aa362&scoped=true&"
import script from "./Recomendaciones.vue?vue&type=script&lang=js&"
export * from "./Recomendaciones.vue?vue&type=script&lang=js&"
import style0 from "./Recomendaciones.vue?vue&type=style&index=0&id=1a5aa362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5aa362",
  null
  
)

export default component.exports